import { IfOnline } from "../OnlineContext";
import {
  Button,
  CardActions,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import AlarmIcon from "@mui/icons-material/Alarm";
import ShareIcon from "@mui/icons-material/Share";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import PencilIconComponent from "./PencilIconComponent";
import AreYouSure from "../AreYouSureComponent";
import EditIcon from "@mui/icons-material/Edit";
import EmailIcon from "@mui/icons-material/Email";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import classnames from "classnames";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import formatDate from "../FormatDate";

const EventCardActions = ({
  handleExpandClick,
  event,
  isRegistered,
  canUserEditEvent,
  handleInterestedClick,
  expanded,
  handleShareClick,
  handleEetlijstClick,
  deleting,
  deleteThisEvent,
  setDeleting,
  settingsMenu,
  setSettingsMenu,
  settingsMenuOpen,
  settingsMenuClose,
}) => {
  const registerText = () => {
    if (opening && opening > now) {
      return `Inschrijving opent ${formatDate(opening, false, false)}`;
    }
    if (deadline < now) {
      return "Inschrijfdeadline verlopen.";
    } else {
      if (regDaysLeft < 1) {
        return `Nog ${Math.floor(regDaysLeft * 24)} uur om in te schrijven!`;
      } else {
        let daysLeft = Math.floor(regDaysLeft);
        if (daysLeft === 1) {
          return `Nog één dag om in te schrijven!`;
        } else {
          return `Nog ${daysLeft} dagen om in te schrijven!`;
        }
      }
    }
  };

  const deadline = event.registrationDeadline
    ? new Date(event.registrationDeadline.iso)
    : undefined;
  const opening = event.registrationOpening
    ? new Date(event.registrationOpening.iso)
    : undefined;
  const now = new Date();
  const openForRegistration =
    event.openForRegistration &&
    (!deadline || deadline > now) &&
    (!opening || opening < now);
  const regDaysLeft = deadline
    ? (deadline.getTime() - now.getTime()) / (1000 * 3600 * 24)
    : undefined;
  const isArchived =
    new Date(
      event.endDate.getFullYear(),
      event.endDate.getMonth(),
      event.endDate.getDate() + 3,
      4,
      0,
      0,
    ) < now;
  const numberOfVisibleButtons =
    (openForRegistration && !isArchived) +
    canUserEditEvent() +
    (event.hasEetlijst && !isArchived) +
    1;
  const showTextWithButton = numberOfVisibleButtons <= 3;
  return (
    <CardActions className="no-padding-top">
      <IfOnline>
        {((openForRegistration && !isArchived) || isRegistered) &&
          (showTextWithButton ? (
            <Button
              size="small"
              color="primary"
              onClick={handleInterestedClick}
              disabled={!openForRegistration || isArchived}
            >
              {isRegistered ? <HowToRegIcon /> : <PersonAddAltOutlinedIcon />}
              <span className={"EventCard-rightIcon"}>
                {isRegistered ? "Ingeschreven" : " Inschrijven"}
              </span>
            </Button>
          ) : (
            <IconButton
              aria-label={isRegistered ? "Uitschrijven" : "Inschrijven"}
              color="primary"
              onClick={handleInterestedClick}
              disabled={!openForRegistration || isArchived}
            >
              {isRegistered ? <HowToRegIcon /> : <PersonAddAltOutlinedIcon />}
            </IconButton>
          ))}

        {(deadline || opening) && !expanded && (
          <IconButton disableRipple={true}>
            <Tooltip
              title={<Typography color="inherit">{registerText()}</Typography>}
              arrow
            >
              <AlarmIcon
                color={
                  deadline < now || opening > now
                    ? "disabled"
                    : regDaysLeft > 2
                      ? "primary"
                      : "error"
                }
              />
            </Tooltip>
          </IconButton>
        )}
      </IfOnline>

      <IconButton aria-label="Delen" color="primary" onClick={handleShareClick}>
        <ShareIcon />
      </IconButton>

      <IfOnline>
        {event.hasEetlijst && !isArchived && (
          <IconButton
            aria-label="Eetlijst"
            color="primary"
            onClick={handleEetlijstClick}
          >
            <FastfoodIcon />
          </IconButton>
        )}

        {canUserEditEvent() && (
          <>
            <IconButton
              aria-label="Instellingen"
              aria-haspopup="true"
              aria-controls="settings-menu"
              color="primary"
              onClick={(e) => settingsMenuOpen(e)}
            >
              <PencilIconComponent />
            </IconButton>
            <AreYouSure
              open={deleting}
              yes={deleteThisEvent}
              no={() => setDeleting(false)}
              text="Weet u zeker dat u dit evenement wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
            />
            <Menu
              id="settings-menu"
              anchorEl={settingsMenu}
              open={Boolean(settingsMenu)}
              onClose={() => setSettingsMenu(null)}
            >
              <MenuItem onClick={() => settingsMenuClose("edit")}>
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>{" "}
                Bewerken
              </MenuItem>
              <MenuItem onClick={() => settingsMenuClose("newsletter")}>
                <ListItemIcon>
                  <EmailIcon />
                </ListItemIcon>{" "}
                Nieuwsbriefstukje maken
              </MenuItem>
              <MenuItem onClick={() => settingsMenuClose("37")}>
                <ListItemIcon>
                  <PostAddIcon />
                </ListItemIcon>{" "}
                Post op De 37 maken
              </MenuItem>
              <MenuItem onClick={() => settingsMenuClose("delete")}>
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>{" "}
                Verwijderen
              </MenuItem>
            </Menu>
          </>
        )}
      </IfOnline>

      {!expanded && (
        <IconButton
          className={classnames("EventCard-expand", {
            ["EventCard-expandOpen"]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="Lees meer"
        >
          <InfoIcon />
        </IconButton>
      )}
    </CardActions>
  );
};

export default EventCardActions;
